import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import admin_avatar_header from "../../../assets/images/avatar.svg";
import { Link } from "react-router-dom";
import DentitstModal from "./DentitstModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteDentist, getDentist } from "../../../Redux/Actions/admin/adminPanel";
import moment from "moment";

const DentistAll = () => {
  const dispatch = useDispatch();
  const dentists = useSelector((state) => state.adminPanel.dentists?.data);
  const dentistpage = useSelector((state) => state.adminPanel.dentists?.pagination);
  const [show, setShow] = useState(false);
  const [dentistDetail, setDentistDetail] = useState();
  const [filter, setFilter] = useState({
    search: undefined,
    date: undefined,
    page: dentistpage?.page || 1,
    limit: dentistpage?.limit || 10,
  });

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setShow(true);
    if (data === "create") {
      setDentistDetail();
    } else {
      setDentistDetail(data);
    }
  };

  useEffect(() => {
    dispatch(getDentist({ filter }));
  }, [filter, dispatch]);

  const handleFilter = (e) => {
    const { value, name } = e.target;
    setFilter({ ...filter, [name]: value, page: 1 }); // Reset to first page on filter change
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= dentistpage?.totalPages) {
      setFilter({ ...filter, page: newPage });
    }
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setFilter({ ...filter, limit: newLimit, page: 1 }); // Reset to first page on limit change
  };

  const renderPageNumbers = () => {
    const pages = [];
    const totalPages = dentistpage?.totalPages || 1;
    const currentPage = filter.page;

    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    return pages;
  };

  return (
    <Layout>
      <div id="layout-wrapper" className="bg-dash admin-table">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <div>
                      <span className="small_text">Dentists</span>
                      <h4 className="mb-sm-0 font-size-28">
                        Dentists
                        <span className="header-title-text">{dentistpage?.total}</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4">
                  <input
                    name="search"
                    type="text"
                    className="form-control filter-input-element"
                    placeholder="Search Here"
                    onChange={handleFilter}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="members_tbl">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 position-relative">
                          <h4 className="title_text">Dentists</h4>
                          <span>
                            <Link>
                              <button
                                type="button"
                                className="btn cre_new"
                                onClick={() => handleShow("create")}
                              >
                                Create New
                              </button>
                            </Link>
                          </span>
                        </div>
                        <div className="table-responsive table-defaut-design dealer-table-c">
                          <table id="datatable" className="table vehicles_table w-100">
                            <thead>
                              <tr>
                                <th>Created</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Consultations Complete</th>
                                <th>Consultations Upcoming</th>
                                <th>Last Login</th>
                                <th>Actions</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody className="td_color trans_table_fix_height">
                              {dentists?.map((item, i) => (
                                <tr key={i}>
                                  <td>{moment(item?.createdAt).format("DD/MM/YYYY")}</td>
                                  <td>{item?.firstName + " " + item?.lastName}</td>
                                  <td>{item?.email}</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>{moment(item?.lastLogin).format("DD/MM/YYYY hh:mm")}</td>
                                  <td className="action_btn editBtn" valign="middle">
                                    <Link to="#">
                                      <button
                                        onClick={() => handleShow(item)}
                                        className="border_btn"
                                      >
                                        Edit
                                      </button>
                                    </Link>
                                  </td>
                                  <td valign="middle" className="delete_button">
                                    <button
                                      onClick={() => dispatch(deleteDentist(item?._id))}
                                      className="btn delete-red-text p-0 m-0"
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="row mt-3">
                          <div className="col-sm-12 col-md-5">
                            <div className="dataTables_info">
                              Showing {dentists?.length || 0} of {dentistpage?.total || 0} entries
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-7">
                            <div className="dataTables_paginate paging_simple_numbers">
                              <ul className="pagination">
                                <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(filter.page - 1)}
                                  >
                                    Previous
                                  </button>
                                </li>
                                {renderPageNumbers()}
                                <li
                                  className={`page-item ${
                                    filter.page === dentistpage?.totalPages ? "disabled" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(filter.page + 1)}
                                  >
                                    Next
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-12">
                            <div className="select-table-bottom-r d-flex justify-content-end">
                              <label>
                                Results per page
                                <select
                                  value={filter.limit}
                                  onChange={handleLimitChange}
                                  className="select-page-count-bottom"
                                >
                                  <option value="10">10</option>
                                  <option value="25">25</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                </select>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DentitstModal show={show} handleClose={handleClose} dentistDetail={dentistDetail} />
    </Layout>
  );
};

export default DentistAll;